import { useState } from "react";
import { ValueGetterParams } from "ag-grid-community";

interface PaginationPropsType {
  currentPage: number;
  pageSize: number;
  searchText: string;
  SortOrder: string | null;
  SortColumn: string;
}

interface ColumnDefinitionType {
  paginationObj: PaginationPropsType;
  setPaginationObj: React.Dispatch<React.SetStateAction<PaginationPropsType>>;
}

const useColumnDefinitions = ({
  paginationObj,
  setPaginationObj,
}: ColumnDefinitionType) => {
  function monthToComparableNumber(date: string) {
    if (date === undefined || date === null || date.length !== 10) {
      return null;
    }
    const yearNumber = Number.parseInt(date.substring(6, 10));
    const monthNumber = Number.parseInt(date.substring(3, 5));
    const dayNumber = Number.parseInt(date.substring(0, 2));

    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
  }
  function dateComparator(date1: string, date2: string) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const CustomHeader = (props: any) => {
    const { column } = props;
    const defaultSortOrder =
      paginationObj.SortColumn === column.getColDef().headerName
        ? paginationObj.SortOrder
        : null;
    const [sortOrder, setSortOrder] = useState<string | null>(defaultSortOrder);
    const handleSortChange = () => {
      // eslint-disable-next-line prefer-const
      let sortColumn = column.getColDef().headerName;

      if (sortOrder === null) {
        setSortOrder("asc");
        setPaginationObj({
          ...paginationObj,
          SortColumn: sortColumn,
          SortOrder: "asc",
        });
      } else if (sortOrder === "asc") {
        setSortOrder("desc");
        setPaginationObj({
          ...paginationObj,
          SortColumn: sortColumn,
          SortOrder: "desc",
        });
      } else {
        setSortOrder(null);
        setPaginationObj({
          ...paginationObj,
          SortColumn: sortColumn,
          SortOrder: null,
        });
      }
    };
    return (
      <div className="custom-header" onClick={handleSortChange}>
        <span>{column.getColDef().headerName}</span>
        <span className="ag-sort-indicator-container" data-ref="eSortIndicator">
          <span
            data-ref="eSortAsc"
            className={`ag-sort-indicator-icon ag-sort-none-icon ${
              sortOrder === "asc" ? "" : "ag-hidden"
            }`}
            aria-hidden="true"
          >
            <span
              className="ag-icon ag-icon-asc"
              unselectable="on"
              role="presentation"
            ></span>
          </span>
          <span
            data-ref="eSortDesc"
            className={`ag-sort-indicator-icon ag-sort-none-icon ${
              sortOrder === "desc" ? "" : "ag-hidden"
            }`}
            aria-hidden="true"
          >
            <span
              className="ag-icon ag-icon-desc"
              unselectable="on"
              role="presentation"
            ></span>
          </span>
          <span
            data-ref="eSortNone"
            className={`ag-sort-indicator-icon ag-sort-none-icon ${
              sortOrder === null ? "" : "ag-hidden"
            }`}
            aria-hidden="true"
          >
            <span
              className="ag-icon ag-icon-none"
              unselectable="on"
              role="presentation"
            ></span>
          </span>
        </span>
      </div>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Header = (props: any) => {
    const { column } = props;
    return (
      <div className="custom-header">
        <span>{column.getColDef().headerName}</span>
      </div>
    );
  };

  const skulistcolheader = [
    {
      cellRenderer: "serialNoRenderer",
      field: "serialNo",
      comparator: () => 0,
      type: "serialNoType",
      headerName: "S.No.",
      sortable: false,
      editable: false,
      resizable: false,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      flex: 1,
      minWidth: 50,
      // maxWidth: 50,
      valueGetter: (params: ValueGetterParams) => {
        return params.node && params.node.rowIndex !== null
          ? params.node.rowIndex + 1
          : 1;
      },
      sort:
        paginationObj.SortColumn === "serialNo" ? paginationObj.SortOrder : "",
      headerClass: ["serialNoHeader"],
      headerComponent: Header,
    },
    {
      cellRenderer: "skuRenderer",
      field: "sku",
      type: "skuType",
      headerName: "SKU #",
      sortable: false,
      editable: false,
      resizable: false,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      flex: 2.2,
      minWidth: 195,
      // maxWidth: 220,
      sort: paginationObj.SortColumn === "sku" ? paginationObj.SortOrder : "",
      headerComponent: CustomHeader,
    },
    {
      cellRenderer: "skuNameCellRenderer",
      field: "skuName",
      type: "skuNameType",
      headerName: "SKU Name",
      flex: 2,
      sortable: false,
      editable: false,
      unSortIcon: true,
      suppressHeaderMenuButton: true,
      resizable: false,
      minWidth: 283,
      sort:
        paginationObj.SortColumn === "skuName" ? paginationObj.SortOrder : "",
      headerComponent: CustomHeader,
    },
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cellRenderer: function (params: any) {
        // return (
        //   dateFunc(params.data.lastUpdatedDate).formattedDateTime +
        //   " " +
        //   params.data.abbreviation
        // );
        return params.data.createdBy;
      },
      field: "createdBy",
      filter: false,
      sortable: false,
      editable: false,
      unSortIcon: true,
      resizable: false,
      flex: 1.5,
      headerName: "Created By",
      type: "createdByType",
      minWidth: 234,
      sort:
        paginationObj.SortColumn === "createdBy" ? paginationObj.SortOrder : "",
      headerComponent: CustomHeader,
    },
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cellRenderer: function (params: any) {
        // return (
        //   dateFunc(params.data.lastUpdatedDate).formattedDateTime +
        //   " " +
        //   params.data.abbreviation
        // );
        return params.data.createdDate;
      },
      field: "createdDate",
      filter: false,
      sortable: false,
      comparator: dateComparator,
      editable: false,
      unSortIcon: true,
      resizable: false,
      flex: 1.5,
      headerName: "Created Date",
      type: "createdDateType",
      minWidth: 158,
      sort:
        paginationObj.SortColumn === "createdDate"
          ? paginationObj.SortOrder
          : "",
      headerComponent: CustomHeader,
    },
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      cellRenderer: function (params: any) {
        // return (
        //   dateFunc(params.data.lastUpdatedDate).formattedDateTime +
        //   " " +
        //   params.data.abbreviation
        // );
        return params.data.updatedDate;
      },
      field: "updatedDate",
      filter: false,
      sortable: false,
      comparator: dateComparator,
      editable: false,
      unSortIcon: true,
      resizable: false,
      flex: 1.5,
      headerName: "Updated Date",
      type: "updatedDateType",
      minWidth: 166,
      sort:
        paginationObj.SortColumn === "updatedDate"
          ? paginationObj.SortOrder
          : "",
      headerComponent: CustomHeader,
    },
    {
      cellRenderer: "statusRenderer",
      field: "status",
      type: "statusType",
      headerName: "Status",
      sortable: false,
      editable: false,
      resizable: false,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
        alignItems: "center",
      },
      flex: 1.5,
      minWidth: 162,
      sort:
        paginationObj.SortColumn === "status" ? paginationObj.SortOrder : "",
      headerComponent: CustomHeader,
    },
    {
      cellRenderer: "updateStatusRenderer",
      field: "updateStatusCd",
      type: "updateStatusType",
      headerName: "Cost Update",
      sortable: false,
      editable: false,
      resizable: false,
      unSortIcon: true,
      cellStyle: {
        whiteSpace: "normal",
        lineHeight: "1.5",
      },
      flex: 2.5,
      minWidth: 178,
      headerComponent: Header,
    },
    {
      cellRenderer: "editRenderer",
      field: "edit",
      type: "editType",
      headerName: "Action",
      sortable: false,
      editable: false,
      resizable: false,
      unSortIcon: true,
      flex: 1.5,
      minWidth: 178,
      suppressClickEdit: true,
      headerComponent: Header,
    },
    {
      flex: 0.5,
    },
  ];
  return skulistcolheader;
};
export default useColumnDefinitions;
